import React from "react";
import {
  HiOutlineExclamationCircle,
  HiOutlineClock,
  HiOutlineBell,
  HiOutlineCheckCircle,
} from "react-icons/hi2";
import { FiExternalLink } from "react-icons/fi";
import "./DashboardTasksCard.scss";

const DashboardTasksCard = ({ tasks = [] }) => {
  const displayTasks = tasks;

  const getTaskIcon = (type) => {
    switch (type) {
      case "pending":
        return HiOutlineClock;
      case "urgent":
        return HiOutlineExclamationCircle;
      case "reminder":
        return HiOutlineBell;
      default:
        return HiOutlineCheckCircle;
    }
  };

  const getTaskColor = (type) => {
    switch (type) {
      case "pending":
        return "orange";
      case "urgent":
        return "red";
      case "reminder":
        return "blue";
      default:
        return "slate";
    }
  };

  return (
    <div className="dashboard-tasks-card" dir="rtl">
      <div className="dashboard-tasks-card__header">
        <h2 className="dashboard-tasks-card__title">פעולות לטיפול</h2>
      </div>

      <div className="dashboard-tasks-card__body">
        {displayTasks.length === 0 ? (
          <div className="dashboard-tasks-card__empty">
            אין פעולות דורשות תשומת לב
          </div>
        ) : (
          <div className="dashboard-tasks-card__list">
            {displayTasks.map((task) => {
              const Icon = getTaskIcon(task.type);
              const color = getTaskColor(task.type);

              return (
                <div
                  key={task.id}
                  className={`dashboard-tasks-card__item dashboard-tasks-card__item--${color}`}
                  onClick={task.action}
                >
                  <div className="dashboard-tasks-card__item-icon">
                    <Icon />
                  </div>
                  <div className="dashboard-tasks-card__item-content">
                    <h3 className="dashboard-tasks-card__item-title">{task.title}</h3>
                    {task.description && (
                      <p className="dashboard-tasks-card__item-description">
                        {task.description}
                      </p>
                    )}
                  </div>
                  <div className="dashboard-tasks-card__item-footer">
                    {task.count > 0 && (
                      <span className="dashboard-tasks-card__item-badge">{task.count}</span>
                    )}
                    <FiExternalLink className="dashboard-tasks-card__item-action" />
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default DashboardTasksCard;
